import type { Directive, DirectiveBinding } from "vue"

/** 创建遮罩层元素 */
const createOverlay = () => {
  const overlay = document.createElement("div")
  overlay.className = "v-loading-mask"
  overlay.innerHTML = '<div class="v-loading-spinner"></div>'
  return overlay
}

const loading: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding<boolean>) {
    const overlay = createOverlay()
    ;(el as any).__loading_overlay = overlay
    if (binding.value) toggle(el, overlay, true)
  },
  updated(el: HTMLElement, binding: DirectiveBinding<boolean>) {
    toggle(el, (el as any).__loading_overlay, binding.value)
  },
  unmounted(el: HTMLElement) {
    const overlay = (el as any).__loading_overlay as HTMLElement
    if (overlay?.parentNode) overlay.parentNode.removeChild(overlay)
  },
}

function toggle(el: HTMLElement, overlay: HTMLElement, show: boolean) {
  if (show) {
    // 记录原始 position，避免覆盖已有的 relative/absolute
    if (!el.style.position || el.style.position === "static") {
      const pos = el.style.position
      ;(el as any).__loading_originalPosition = pos
      el.style.position = "relative"
    }
    if (!overlay.parentNode) el.appendChild(overlay)
  } else {
    // 恢复原始 position
    const original = (el as any).__loading_originalPosition
    if (original !== undefined) {
      el.style.position = original
      delete (el as any).__loading_originalPosition
    }
    if (overlay?.parentNode) overlay.parentNode.removeChild(overlay)
  }
}

/** 注入全局样式（只执行一次） */
let styleInjected = false
export const injectLoadingStyle = () => {
  if (styleInjected) return
  styleInjected = true
  const style = document.createElement("style")
  style.textContent = `
.v-loading-mask {
  position: absolute;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
}
.v-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e8e8e8;
  border-top-color: #48b02c;
  border-radius: 50%;
  animation: v-loading-spin 0.8s linear infinite;
}
@keyframes v-loading-spin {
  to { transform: rotate(360deg); }
}`
  document.head.appendChild(style)
}

export default loading
